export interface FinancingTab {
  id: string;
  label: string;
  documents: string[];
}

export const financingTabs: FinancingTab[] = [
  {
    id: "salaries",
    label: "Salariés",
    documents: [
      "Pièce d'identité recto verso en cours de validité",
      "Justificatif d'adresse de moins de 3 mois",
      "2 derniers mois de relevés de compte",
      "2 derniers bulletins de salaire",
      "RIB du compte de prélèvement",
      "Dernier avis d'imposition",
      "Si CDI depuis moins d'un an : contrat de travail",
    ],
  },
  {
    id: "retraites",
    label: "Retraités",
    documents: [
      "Pièce d'identité recto verso en cours de validité",
      "Justificatif d'adresse de moins de 3 mois",
      "Bulletin de pension ou retraite",
      "2 derniers mois de relevés de compte",
      "RIB du compte de prélèvement",
      "Dernier avis d'imposition",
    ],
  },
  {
    id: "professionnels",
    label: "Professionnels",
    documents: [
      "Pièce d'identité recto verso en cours de validité",
      "Justificatif d'adresse de moins de 3 mois",
      "2 derniers mois de relevés de compte",
      "RIB du compte de prélèvement",
      "Dernier avis d'imposition",
      "KBIS",
    ],
  },
];